import {MyPageSecondTab, Sort} from './type';
import {IS_CLIENT} from '../../common/constant';
import {Page} from '../../common/constant/page';
import {routeTo} from '../../common/util/PageRouter';
import {getLocalStorageObject} from '../../common/util/storage';
import {HomeTabPage} from '../common/type';

export const MY_PAGE_VIEW_PARAMS: {
  [key in MyPageSecondTab]: {page: string; actionNameAndSort: string};
} = {
  recent: {
    page: 'library_recent',
    actionNameAndSort: 'recent',
  },
  like: {
    page: 'library_favorite',
    actionNameAndSort: 'favorite',
  },
  own: {
    page: 'library_purchased',
    actionNameAndSort: 'purchased',
  },
};

export const routeToMyPage = (isRouteToMyPage: boolean) => {
  if (isRouteToMyPage) {
    routeTo(
      {
        page: Page.Home,
        home: HomeTabPage.MyPage,
      },
      {
        isReplace: true,
      }
    );
  }
};

export const MY_PAGE_SORT_LS_MAP: {[key in MyPageSecondTab]: string} = {
  recent: 'my-page-recent-sort',
  like: 'my-page-like-sort',
  own: 'my-page-purchase-sort',
};

export const getLocalSortInfo = (tab: MyPageSecondTab) => {
  if (!IS_CLIENT) {
    return undefined;
  }

  return getLocalStorageObject<Required<Sort>>({
    key: MY_PAGE_SORT_LS_MAP[tab],
  });
};
